import { renderResearchText } from "@/components/ResearchText";

export const HsbcReferences = ({ items, testId }) => <ol className="article-references" data-testid={`${testId}-list`}>
  {items.map((item) => <li id={`reference-${item.number}`} key={item.number} data-testid={`hsbc-reference-${item.number}`}>
    <span data-testid={`hsbc-reference-${item.number}-number`}>[{item.number}]</span>
    <p data-testid={`hsbc-reference-${item.number}-text`}>{renderResearchText(item.text, `hsbc-reference-${item.number}`)}</p>
  </li>)}
</ol>;